import { combineReducers } from "redux";

import storage from "redux-persist/lib/storage";
// slices
import clientslReducer from "./slices/clients";
import usersReducer from "./slices/users";
import categoriesReducer from "./slices/categories";
import generalReducer from "./slices/general";
import departmentsReducer from "./slices/departments";
import servicesReducer from "./slices/services";
import appointmentsReducer from "./slices/appointments";
// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const rootReducer = combineReducers({
  clients: clientslReducer,
  users: usersReducer,
  categories: categoriesReducer,
  general: generalReducer,
  departments: departmentsReducer,
  services: servicesReducer,
   appointments: appointmentsReducer,
});

export { rootPersistConfig, rootReducer };
